import React from 'react';

/** Simple 7-day revenue sparkline (no chart library). */
const RevenueChart = ({ data = [] }) => {
  const values = (Array.isArray(data) ? data : [])
    .map((v) => Number(v))
    .filter((v) => typeof v === 'number' && !Number.isNaN(v) && Number.isFinite(v));

  if (values.length === 0) {
    return <div className="revenue-chart revenue-chart--empty">No revenue data for the last 7 days</div>;
  }

  const width = 600;
  const height = 120;
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const range = max - min || 1;
  const denom = Math.max(values.length - 1, 1);

  const points = values
    .map((v, i) => {
      const x = (i / denom) * width;
      const y = height - ((v - min) / range) * (height - 8) - 4;
      return `${x},${y}`;
    })
    .join(' ');

  const total = values.reduce((s, v) => s + v, 0);

  return (
    <div className="revenue-chart">
      <div className="revenue-chart-summary">
        <span>Last 7 days</span>
        <strong>£{total.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</strong>
      </div>
      <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
        <polyline fill="none" stroke="#2563eb" strokeWidth="2.5" points={points} />
      </svg>
    </div>
  );
};

export default RevenueChart;
